import React, { useState, useRef, useEffect } from 'react';
import Calendar from 'react-calendar';
import 'react-calendar/dist/Calendar.css';
import { Text } from '@cuemath/web-comps';

import { PickerWrap, PickerField, PickerPop, UI } from '../../styled-comps';
import { formatDisplayDate } from '../../helpers';

// Date-range picker on react-calendar: clicking the header label drills up to
// month / year / decade views, so any month or year in [minDate, maxDate] is
// reachable (the old hand-rolled picker had no year navigation).
const RangePicker = ({ start, end, minDate, maxDate, onChange }) => {
  const [open, setOpen] = useState(false);
  const wrapRef = useRef(null);

  useEffect(() => {
    if (!open) return undefined;
    const onDocClick = event => {
      if (wrapRef.current && !wrapRef.current.contains(event.target)) setOpen(false);
    };
    document.addEventListener('mousedown', onDocClick);
    return () => document.removeEventListener('mousedown', onDocClick);
  }, [open]);

  return (
    <PickerWrap ref={wrapRef}>
      <PickerField onClick={() => setOpen(prev => !prev)}>
        <Text variant="body3" color={UI.ink}>
          {`${formatDisplayDate(start)}  →  ${formatDisplayDate(end)}`}
        </Text>
      </PickerField>
      {open && (
        <PickerPop>
          <Calendar
            selectRange
            value={[start, end]}
            minDate={minDate}
            maxDate={maxDate}
            onChange={range => {
              if (Array.isArray(range) && range[0] && range[1]) {
                onChange(range[0], range[1]);
                setOpen(false);
              }
            }}
          />
        </PickerPop>
      )}
    </PickerWrap>
  );
};

export default RangePicker;
